export enum ICONS {
    backOutlined = 'navigation--back_outlined',
    nextFilled = 'navigation--next_filled',
    expandFilled = 'ui--expand_filled',
    moreMenuVerticalOutlined = 'navigation--more-menu-vertical_outlined',
    reportingReportOutlined = 'reporting--report_outlined',
    reportingSummaryChartOutlined = 'reporting--summary-chart_outlined',
    formattingCharacterSpacingOutlined = 'formatting--character-spacing_outlined',
    actionSearchForTextOutlined = 'action--search-for-text_outlined',
    homeFilled = 'navigation--home_outlined',
}
